import { useMutation } from '@tanstack/react-query'
import {
  deleteNotificationDestination,
  DeleteNotificationDestinationRequest,
} from 'services/WebHooksService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { logSentryError } from 'utils/sentry'

export const useDeleteNotificationDestinationMutation = () => {
  return useMutation({
    mutationFn: (data: DeleteNotificationDestinationRequest) => deleteNotificationDestination(data),
    onError(error: BaseErrorResponse, data) {
      logSentryError('Error from useDeleteWebhookDestinationMutation', error, data)
    },
  })
}
